export default "__VITE_ASSET__BLSD_xmD__"